import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import clsx from "clsx";
import { useSelector } from "react-redux";
import Logo from "../../components/header/Logo";
import NavMenu from "../../components/header/NavMenu";
import IconGroup from "../../components/header/IconGroup";
import MobileMenu from "../../components/header/MobileMenu";
import HeaderTop from "../../components/header/HeaderTop";

const HeaderOneMain = ({
  layout,
  top,
  borderStyle,
  headerPaddingClass,
  headerPositionClass,
  headerBgClass,
  ...otherProps
}) => {
  const [scroll, setScroll] = useState(0);
  const [headerTop, setHeaderTop] = useState(0);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 992); // lg 브레이크포인트
  const transparent_header = 1;
  
  // 로그인 상태 확인
  const { isUserLoggedIn, isAdminLoggedIn } = useSelector((state) => state.withcookie);
  // const isLoggedIn = isUserLoggedIn || isAdminLoggedIn;
  const isLoggedIn = isUserLoggedIn; // 관리자 로그인 무시

  // Redux 상태에서 withcookieData 및 메뉴 데이터 가져오기
  const withcookieData = useSelector(state => state.withcookie?.withcookieData);
  const globalMenus = useSelector(state => state.withcookie?.globalMenus);
  const mainMenus = useSelector(state => state.withcookie?.mainMenus);
  
  // 로고 URL 가져오기 (API 데이터가 있으면 그것을 사용, 없으면 기본 이미지)
  const logoUrl = withcookieData?.skin?.theme?.main_logo_url || "/assets_flone/img/logo/logo.png";

  // 테마 색상 가져오기
  const theme = withcookieData?.skin?.theme || {};
  const colorSet = theme?.colorset || {};
  const primaryColor = colorSet?.primary || "#181B42";
  const secondaryColor = colorSet?.secondary || "#313AB9";

  // 화면 크기 감지를 위한 useEffect 추가
  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth >= 992); // Bootstrap lg 브레이크포인트
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const scrollContainer = document.querySelector('.preview-container');
    if (!scrollContainer) return;

    const handleScroll = () => {
      setScroll(scrollContainer.scrollTop);
      // 디버깅용
    };

    scrollContainer.addEventListener("scroll", handleScroll);
    // 초기값도 세팅
    setScroll(scrollContainer.scrollTop);

    return () => {
      scrollContainer.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // 사용할 메뉴 데이터 결정
  // 1. 먼저 Redux에서 가져온 메뉴 데이터 사용
  // 2. 없으면 props로 받은 미리보기 데이터 사용
  // 3. 둘 다 없으면 빈 배열 사용
  let menusToUse = [];
  
  // Redux 메뉴 데이터가 있는 경우
  if (Array.isArray(mainMenus) && mainMenus.length > 0) {
    menusToUse = [...mainMenus];
    
    // 글로벌 메뉴가 있으면 추가
    if (Array.isArray(globalMenus)) {
      menusToUse = [...menusToUse, ...globalMenus];
    }
  } 
  // props로 받은 미리보기 데이터가 있는 경우
  else if (otherProps.previewData?.menus) {
    menusToUse = otherProps.previewData.menus;
  }
  // 에디터 데이터가 있는 경우
  else if (otherProps.editorData?.menus) {
    menusToUse = otherProps.editorData.menus;
  }

  // 헤더 스타일
  const headerStyle = {
    backgroundColor:
      transparent_header === 1
        ? (scroll > 0 ? primaryColor : "transparent")
        : primaryColor,
    transition: "background-color 0.3s",
    position:
      transparent_header === 1
        ? "fixed"
        : undefined,
    zIndex: transparent_header === 1 ? 9999 : undefined,
    width: transparent_header === 1 ? "100%" : undefined,
    top: transparent_header === 1 ? 0 : undefined,
    // 데스크톱에서만 96px 높이 적용
    ...(isDesktop && {
      minHeight: "96px",
      height: "96px"
    }),
    padding: 0 // 패딩도 고정
  };

  // 헤더 텍스트 스타일 (흰색 또는 어두운 배경에 맞는 색상)
  const headerTextStyle = {
    color:
      transparent_header === 1
        ? (scroll > 0 ? "#FFFFFF" : primaryColor)
        : "#FFFFFF"
  };

  return (
    <header className={clsx("header-area clearfix", headerBgClass, headerPositionClass)}>
      <div
        className={clsx(
          "header-top-area", 
          headerPaddingClass, top === "visible" ? "d-none d-lg-block" : "d-none", 
          borderStyle === "fluid-border" && "border-none" 
        )}
        style={headerStyle}
      >
        <div className={layout === "container-fluid" ? layout : "container"}>
          {/* header top */}
          <HeaderTop borderStyle={borderStyle} textStyle={headerTextStyle} />
        </div>
      </div>

      <div
        className={clsx(
          headerPaddingClass, 
          "sticky-bar header-res-padding clearfix", 
          scroll > headerTop && "stick"
        )}
        style={headerStyle}
      >
        <div className={layout === "container-fluid" ? layout : "container"}>
          <div className="row" style={{ paddingTop: '10px',paddingBottom: '10px' }}>
            <div className="col-xl-2 col-lg-2 col-md-6 col-4">
              {/* header logo */}
              {scroll > 0 && (
                <Logo imageUrl={logoUrl} logoClass="logo" />
              )}
            </div>
            <div className="col-xl-8 col-lg-8 d-none d-lg-block">
              {/* Nav menu */}
              <NavMenu 
                menus={menusToUse}
                textStyle={headerTextStyle}
                isLoggedIn={isLoggedIn}
              />
            </div>
            <div className="col-xl-2 col-lg-2 col-md-6 col-8">
              {/* Icon group */}
              <IconGroup textStyle={headerTextStyle} />
            </div>
          </div>
        </div>
        {/* mobile menu */}
        <MobileMenu 
          menus={menusToUse}
          isLoggedIn={isLoggedIn}
        />
      </div>
    </header>
  );
};

HeaderOneMain.propTypes = {
  borderStyle: PropTypes.string,
  headerPaddingClass: PropTypes.string,
  headerPositionClass: PropTypes.string,
  layout: PropTypes.string,
  top: PropTypes.string
};

export default HeaderOneMain;
